// Rota basina meta verisi. Iki yerde kullaniliyor:
//   1) scripts/prerender.js -> build sirasinda <head> icine statik olarak basar
//   2) src/seo/useSeo.js    -> client-side navigasyonda head'i gunceller
// Tek kaynak oldugu icin ikisi hicbir zaman birbirinden ayrisamaz.

import { SITE_URL, leaders, getLeaderBySlug, leaderPath } from '../data/leaders';

export { SITE_URL };

// Sosyal paylasim gorselleri: scripts/og-images.js ile uretilen 1200x630 JPEG'ler.
// WhatsApp kucuk (or. 309x78 logo) ve saydam gorselleri onizlemeye almiyor,
// bu yuzden opak ve tam olculu olmalari onemli.
const OG_IMAGE_WIDTH = 1200;
const OG_IMAGE_HEIGHT = 630;
const OG_IMAGE_TYPE = 'image/jpeg';
const DEFAULT_OG_IMAGE = `${SITE_URL}/site/assets/img/og/og-default.jpg`;
const DEFAULT_OG_IMAGE_ALT = 'GloworKs — We Make Beauty Work';

const SITE_NAME = 'GloworKs';

const homeMeta = {
    title: 'GloworKs | We Make Beauty Work',
    description:
        'GloworKs builds, operates, and scales beauty and personal care brands with a senior leadership team that is as close to execution as it is to strategy.',
    path: '/',
};

const leaderMeta = (leader) => ({
    title: `${leader.name} — ${titleCase(leader.role)} | GloworKs`,
    description: leaderDescription(leader),
    path: leaderPath(leader),
    ogImage: `${SITE_URL}/site/assets/img/og/og-team-${leader.slug}.jpg`,
    ogImageAlt: `${leader.name}, ${titleCase(leader.role)} at GloworKs`,
    ogType: 'profile',
});

const contactMeta = {
    title: 'Contact | GloworKs',
    description:
        'Get in touch with GloworKs. Office in Kadikoy, Istanbul; email support@gloworkspartner.com to talk about scaling your beauty or personal care brand.',
    path: '/contact',
};

const notFoundMeta = {
    title: 'Page not found | GloworKs',
    description: 'The page you are looking for does not exist.',
    path: '/404',
    noindex: true,
};

// Rol adlari veride buyuk harf tutuluyor ("HEAD OF E-COMMERCE"); baslik ve
// description icinde okunakli olmasi icin duzeltiliyor.
const LOWERCASE_WORDS = new Set(['of', 'and', 'the', 'in', 'for', 'to', 'a', 'an']);

function titleCase(value) {
    return value
        .toLowerCase()
        .split(' ')
        .map((word, index) => {
            if (index > 0 && LOWERCASE_WORDS.has(word)) return word;
            return word.includes('-') ? word.split('-').map(capitalize).join('-') : capitalize(word);
        })
        .join(' ');
}

function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

// Google description'i ~160 karakterde kesiyor. Once isim + unvan + deneyim
// (asil aranan bilgi), yer kalirsa CV'nin ilk cumlesi eklenir; sigmiyorsa
// yarim cumle yerine hic eklenmez.
const DESCRIPTION_LIMIT = 158;

function leaderDescription(leader) {
    const base = `${leader.name}, ${titleCase(leader.role)} at GloworKs. ${leader.exp}.`;
    const sentence = firstSentence(leader.cv);

    if (sentence && `${base} ${sentence}`.length <= DESCRIPTION_LIMIT) return `${base} ${sentence}`;
    return base;
}

function firstSentence(cv) {
    if (!cv) return '';
    const first = cv.split('\n')[0].trim();
    const match = first.match(/^.*?[.!?](\s|$)/);
    return (match ? match[0] : first).trim();
}

// Bir pathname icin tam meta nesnesi dondurur.
export function metaForPath(pathname) {
    const clean = pathname.replace(/\/+$/, '') || '/';

    if (clean === '/') return withDefaults(homeMeta);

    if (clean === '/contact') return withDefaults(contactMeta);

    const teamMatch = clean.match(/^\/team\/([^/]+)$/);
    if (teamMatch) {
        const leader = getLeaderBySlug(teamMatch[1]);
        if (leader) return withDefaults(leaderMeta(leader));
    }

    return withDefaults(notFoundMeta);
}

function withDefaults(meta) {
    return {
        ogImage: DEFAULT_OG_IMAGE,
        ogImageAlt: DEFAULT_OG_IMAGE_ALT,
        ogImageWidth: OG_IMAGE_WIDTH,
        ogImageHeight: OG_IMAGE_HEIGHT,
        ogImageType: OG_IMAGE_TYPE,
        ogType: 'website',
        noindex: false,
        siteName: SITE_NAME,
        ...meta,
        canonical: `${SITE_URL}${meta.path === '/' ? '/' : meta.path}`,
    };
}

// Prerender edilecek butun rotalar. sitemap.xml uretimi de bunu kullanabilir.
export const routes = ['/', '/contact', ...leaders.map(leaderPath)];
